export const backupShopifyConfiguration = (companyName) => {
  const deliveryInstructions =
  companyName === 'Lippi' || companyName === 'Haka Honu'
    ? 'company'
    : 'address2'
  const ssnField =
  companyName === 'SELFIE'
    ? 'company'
    : 'zip'
  return {
    data: {
      shopifyConfiguration: {
        cityField: 'city',
        streetNameField: 'address1',
        buildingNumberField: 'address1',
        deliveryInstructionsField: deliveryInstructions,
        ssnField,
        paymentMethods: [
          'Mercado Pago'
        ],
        useScrapper: true
      }
    }
  }
}
